import React, { useEffect, useRef } from 'react';
import assets from 'shared/assets';
import Wrapper, { Img, Canvas, Container } from './styles';
import * as d3 from 'd3';
import { isMobile, randomBetweenInterval } from 'shared/helpers';

const DoctorAnimated = () => {
  const canvas = useRef();
  const img = useRef();
  const container = useRef();

  useEffect(() => {
    if(!canvas.current) return;
    if(!container.current) return;

    const mult = isMobile() ? 0.9 : 0.35;

    const c = canvas.current;
    const context = c.getContext('2d');
    const width = window.innerWidth * mult;
    const height = width * 1.47;



    c.width = width;
    c.height = height;

    let svg;

    const i = new Image(width, height);
    i.src = assets.doctor;
    i.onload = () => {
      context.drawImage(i, 0, 0, width, height);
      svg = d3.select(container.current).append('svg')
              .attr('width', width)
              .attr('height', height)
              .append('g')

      pixelate(i, 7)
    }

    const pixelate = (i, size) => {
      const xSquares = i.width / size;
      const ySquares = i.height / size;
      let data = [];
      for (let x = 0; x < xSquares; x++) {
        for (let y = 0; y < ySquares; y++) {
          const rgba = context.getImageData(x*size, y*size, size, size).data;
          const len  = rgba.length;
          const num  = len / 4;
          let r = 0;
          let g = 0;
          let b = 0;
          // Sum the color values.
          for (let i = 0; i < len; i += 4) {
            r += rgba[i];
            g += rgba[i+1];
            b += rgba[i+2];
          }
          // Save the position and average color value.
          data.push({
            x   : x*size,
            y   : y*size,
            rgb : 'rgb(' + [
              Math.round(r / num),
              Math.round(g / num),
              Math.round(b / num)
            ].join(',') + ')'
          });
        }
      }
      drawSvg(data, size);
    }

    const drawSvg = (colors, size) => {
      const squares = svg.selectAll('.square').data(colors);
      const s = squares.enter().append('circle')
        .attr('class', 'square')
        .attr('cx', d => d.x)
        .attr('cy', d => d.y)
        .attr('r', size)
        .attr('opacity', 1)
        .attr('id', (d, i) => 'square-' + i)
        .attr('fill', d => {
          if(d.rgb === 'rgb(0,0,0)'){
            d.noshow = true;
            return 'transparent';
          }
          return d.rgb;
        })
    setTimeout(() => {
      s.each((d, i) => {
        const n = d3.select('#square-' + i);
        
        n.transition()
          .attr('cx', () => {
            return randomBetweenInterval(size, width)
          })
          .attr('cy', () => {
            return randomBetweenInterval(size, height)
          })
          .duration(5000)

        n.transition(0)
         .attr('opacity', 0)
         .duration(5000)
    
      })

      setTimeout(() => {
        const btn = document.getElementById('drawer-button');
        btn.click();
      }, 5000);
    }, 1500);
    
      
    }



  }, [canvas, img, container]);

  return(
    <Wrapper>
      <Img src={assets.doctor} ref={img} />  
      <Canvas ref={canvas}/>
      <Container ref={container}/>
    </Wrapper>
  )
}

export default DoctorAnimated;